import React, { Component } from 'react';
import AFBTest from './testForms/afb';
import HIV from './testForms/hiv';
import GeneXpert from './testForms/geneXpert';
import LFT from './testForms/lft';
import KFT from './testForms/kft';
import FBS from './testForms/fbs';
import FBC from './testForms/fbc';

class AddTest extends Component{
    constructor(){
        super()
        this.state = {
            type: '',
            typeField: true,
        }
    }
    handleSelect = (e) =>{
        this.setState({
            type: e.target.value
        })
    }
    hideTypeField = () =>{
        this.setState({
            typeField: false
        })
    }
    render(){
        const {type, typeField} = this.state;
        const {refresh} = this.props;
        return(
            <div className="add-tests">
                <h4 className="section-title">Add test result</h4>
                <form onSubmit={this.handleSubmit}>
                    {
                        typeField && 
                        <label>
                            Test Name
                            <select onChange={this.handleSelect}>
                                <option>Select...</option>
                                <option value="afb">AFB Test</option>
                                <option value="hiv">HIV</option>
                                <option value="gene-xpert">GeneXpert</option>
                                <option value="lft">Liver Function Test</option>
                                <option value="kft">Kidney Function Test</option>
                                <option value="fbc">Full Blood Count</option>
                                <option value="fbs">Fasting Blood Sugar</option>
                            </select>
                        </label>
                    }
                    {
                        type === 'afb' &&
                        <AFBTest  handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                    {
                        type === 'hiv' &&
                        <HIV handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                    {
                        type === 'gene-xpert' &&
                        <GeneXpert handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                    {
                        type === 'lft' &&
                        <LFT handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                    {
                        type === 'kft' &&
                        <KFT handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                    {
                        type === 'fbc' &&
                        <FBC handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                    {
                        type === 'fbs' &&
                        <FBS handleClose={this.props.handleClose} hideField={this.hideTypeField} refresh={refresh}/>
                    }
                </form>
            </div>
        )
    }
}

export default AddTest;


// WEBPACK FOOTER //
// ./src/components/patientProfile/AddTests.js